

// Select all video elements with the .hero-json class
const videoElements = document.querySelectorAll(".hero-json");

// Add event listener to each video to prevent touch interaction
videoElements.forEach(video => {
  video.addEventListener("touchstart", function(e) {
    e.preventDefault(); // Prevents default interaction with the video
  });
});
